import React from 'react'

import Svg from './..'

const HomebotIcon = (props) => {
  return (
    <Svg viewBox="0 0 20 20" width={20} height={20} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.952 10c0 5.497-4.456 9.952-9.952 9.952C4.503 19.952.048 15.497.048 10S4.503.048 10 .048c5.496 0 9.952 4.455 9.952 9.952zM1.16 10a8.841 8.841 0 1017.682 0A8.841 8.841 0 001.16 10z"
        fill="#FC5AA6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.959 11.101a1.2 1.2 0 11-.001-2.4 1.2 1.2 0 01.001 2.4zm-3.895 0a1.2 1.2 0 11-.001-2.4 1.2 1.2 0 01.001 2.4zm-1.163 3.225h6.203a.78.78 0 00.78-.78v-1.32h.457a.42.42 0 00.42-.42v-1.697a.42.42 0 00-.42-.42h-.457V8.027a.78.78 0 00-.78-.779h-2.885V6.78a1.232 1.232 0 10-.442-.01v.477H6.9a.78.78 0 00-.78.78V9.69h-.463a.42.42 0 00-.42.42v1.696c0 .231.188.42.42.42h.464v1.32c0 .43.349.78.78.78zm.251-1.602c0-.284.23-.514.514-.514h4.8a.514.514 0 010 1.027h-4.8a.514.514 0 01-.514-.513z"
        fill="#F3EFF1"
      />
    </Svg>
  )
}

export default HomebotIcon
